import Image from '@/components/UI/Image';
import { queryIntegrateSku } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { memo } from 'react';
import SpecsItem from './SpecsItem';
import css from './index.module.scss';
const mm100CatagoryId = '1514858700785975298';

const formatSpecData = (data: any[]) => {
    if (!data.length) return;
    const formatData = data.map((item) => {
        const { name, generalKey, productCatagoryId, ownSpec } = item;
        const specGroupMap = JSON.parse(ownSpec || '{}');
        const arrayList = [];
        for (const g in specGroupMap) {
            const group = specGroupMap[g];
            for (const s in group) {
                let value = group[s];
                if (typeof value === 'boolean') {
                    value = value ? '✓' : '–';
                } else if (value === 'true') {
                    value = '✓';
                } else if (value === 'false') {
                    value = '–';
                }
                arrayList.push({
                    key: s,
                    unit: '',
                    value,
                    generalKey,
                });
            }
        }
        return { name, generalKey, productCatagoryId, arrayList };
    });
    return formatData;
};

function Child() {
    const { useState, useEffect, useLang, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('ecoflowpowerkitsseries');
    const [productCatagoryData, setProductCatagoryData] = useState([]);

    useEffect(() => {
        getProductCatagoryData();
    }, []);

    const getProductCatagoryData = async () => {
        // 第一种
        // const { data: productInfo } = await queryComparisonProductInfo({
        //     comparisonProductList: mm100List
        // }, locale)
        // const { data: catagoryData } = await productCatagory({ productCatagoryId: mm100CatagoryId }, locale)
        // const specsData = formatProductSpecData(catagoryData, productInfo)
        // 第二种
        const { data } = await queryIntegrateSku(
            {
                productCatagoryId: mm100CatagoryId,
            },
            locale,
        );
        const formatData = formatSpecData(data || []);
        setProductCatagoryData(formatData);
    };

    return (
        <div className={`power-kit-presale-specs ${css.presaleSpecs}`}>
            <div className="product">
                <Image
                    src="/img/powerKitPreSale/power-kits-specs.jpg"
                    layout="fill"
                    className="fullImgs"
                    alt={t('presale.specs.power_kits_specs')}
                    aria-label={t('presale.specs.power_kits_specs')}
                />
            </div>
            <SpecsItem productCatagoryData={productCatagoryData} />
        </div>
    );
}

const ChildMemo = memo(Child);

export default function Specs() {
    return <ChildMemo />;
}
